app.controller("EditQuestionnaireParamsWindowController", ["$scope", "params", "$uibModalInstance", "StaticData", "QuestionnairesService",
    function ($scope, params, $uibModalInstance, StaticData, QuestionnairesService) {
        $scope.questionnaire = params.questionnaire;
        $scope.dateOptions = {
            "is-open": "false",
            dateDisabled: false,
            formatYear: 'yyyy',
            startingDay: 1
        };
        $scope.popup1 = {
            opened: false
        };
        $scope.popup2 = {
            opened: false
        };
        $scope.popup3 = {
            opened: false
        };

        $scope.mandatoryDate = new Date(params.questionnaire.mandatoryDate);
        $scope.activeDateFrom = new Date(params.questionnaire.activeDateFrom);
        $scope.activeDateTo = new Date(params.questionnaire.activeDateTo);
        $scope.activeTimeFrom = params.questionnaire.activeDateFrom || new Date(2019, 0, 0, 0, 0);
        $scope.activeTimeTo = params.questionnaire.activeDateTo || new Date(2019, 0, 0, 0, 0);

        $scope.openMandatoryDate = function () {
            $scope.popup1.opened = true;
        };

        $scope.openActiveFromDate = function () {
            $scope.popup2.opened = true;
        };

        $scope.openActiveToDate = function () {
            $scope.popup3.opened = true;
        };

        $scope.submit = function () {
            $scope.activeDateFrom.setHours(new Date($scope.activeTimeFrom).getHours());
            $scope.activeDateFrom.setMinutes(new Date($scope.activeTimeFrom).getMinutes());
            $scope.activeDateTo.setHours(new Date($scope.activeTimeTo).getHours());
            $scope.activeDateTo.setMinutes(new Date($scope.activeTimeTo).getMinutes());

            QuestionnairesService.updateMandatory({
                questionnaireId: $scope.questionnaire._id,
                finishLimit: $scope.questionnaire.finishLimit,
                mandatoryDate: $scope.mandatoryDate,
                activeDateFrom: $scope.activeDateFrom,
                activeDateTo: $scope.activeDateTo,
            }).then(function () {
                $uibModalInstance.close();
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
